var React = require('react');

function ChevronRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","d":"M8.538 20.505l8.602-8.447-8.602-8.446","fill":"none","strokeLinecap":"square","strokeLinejoin":"round"}));
}

ChevronRightInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ChevronRightInline;

ChevronRightInline.default = ChevronRightInline;
